export const names = Object.freeze({
    login: "Login",
    redirect: "Redirect",
    logout: "Logout",
  });